import WorkOrderRoutes from "./work-oder";
import ProductionRoutes from "./production";
import MaintenanceOrder from "./maintenance-order";
import BillOfMaterialsRoutes from "./bill-of-materials";
import PlanningRoutes from "./planning";
import ProcessCapacityRoutes from "./process-capacity";
import ScheduleRoutes from "./schedule";
import QualityControlRoutes from "./quality-control";

export default [
  ...WorkOrderRoutes,
  ...ProductionRoutes,
  ...MaintenanceOrder,
  ...BillOfMaterialsRoutes,
  ...PlanningRoutes,
  ...ProcessCapacityRoutes,
  ...ScheduleRoutes,
  ...QualityControlRoutes,
];
